import {Box, Container, Link, Typography} from '@mui/material';

export default function Footer() {
  return (
    <Box component="footer" className="footer">
      <Container className="footer-container">
        <Box className="footer-content">
          <Box>
            <Typography className="footer-copyright">
              © {new Date().getFullYear()} Quizzler. Alle Rechte vorbehalten.
            </Typography>
          </Box>
          <Box className="footer-links">
            <Link href="#" className="footer-link">
              Datenschutz
            </Link>
            <Link href="#" className="footer-link">
              Impressum
            </Link>
            <Link href="#" className="footer-link">
              Nutzungsbedingungen
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
} 